import React, { useState } from "react";
import Moment from "react-moment";

const InvDate = ({ date }) => {
  return <Moment format="D MMM YYYY">{date}</Moment>;
};

export default InvDate;
